import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import LyocBlurb from '@/components/static/LyocBlurb';
import LyocLinks from '@/components/static/LyocLinks';
import LyocTitle from '@/components/static/LyocTitle';
import { getUnAuth } from '@/config/axiosConfig';
import { setLyocCookie } from '@/Cookies';
import { logg } from '@/util/logg';

interface LoginProps {
	setToken: (token: string) => void;
}

const Login = ({ setToken }: LoginProps) => {
	const navigate = useNavigate();
	const [username, setUsername] = useState<string>('');
	const [password, setPassword] = useState<string>('');

	async function loginUser(
		username: string,
		password: string
	): Promise<string | null> {
		const loginParams = `login?username=${username}&password=${password}`;

		try {
			const response = await getUnAuth(loginParams);
			if (!response) {
				return null;
			}
			return response.data;
		} catch (e) {
			logg(e);
			return null;
		}
	}

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const token = await loginUser(username, password);
		if (token == null) {
			alert('Unable to login. Are the email and password correct?');
			return;
		}

		// Redundant, but so we can load the token from the cookie on reload
		setLyocCookie(token);
		setToken(token);
		window.location.href = '/';
	};

	const handleNavigateToRegister = async (e: any) => {
		e.preventDefault();
		navigate('../register', { replace: true });
	};

	const handleNavigateToSinglePlayer = async (e: any) => {
		e.preventDefault();
		navigate('../game-hub', { replace: true });
	};

	return (
		<>
			{/*<button onClick={(e) => handleNavigateCubeDrop(e)}>CubeDrop</button>*/}
			<LyocTitle showImg={true} />
			<LyocBlurb />

			<div className="login-form">
				<form onSubmit={handleSubmit}>
					<label>
						<p>Email or Username</p>
						<input
							type="text"
							onChange={(e) => setUsername(e.target.value)}
						/>
					</label>
					<label>
						<p>Password</p>
						<input
							type="password"
							onChange={(e) => setPassword(e.target.value)}
						/>
					</label>

					<div className="flexRow">
						<div>
							<button type="submit">Submit</button>
						</div>
						<button
							onClick={(e) => {
								handleNavigateToRegister(e);
							}}
						>
							Register
						</button>
					</div>
				</form>

				<button
					onClick={(e) => {
						handleNavigateToSinglePlayer(e);
					}}
				>
					Play Offline (No Login Required)
				</button>
			</div>

			<LyocLinks />
		</>
	);
};

export default Login;
